export const textVariants = {
  mealTitle: "tw-text-meal-title",
  largeTitle: "tw-text-large-title",
  title1: "tw-text-title-1",
  title2: "tw-text-title-2",
  title3: "tw-text-title-3",
  body: "tw-text-body",
  bodySingleLine: "tw-text-body-single-line",
  bodySmall: "tw-text-body-small",
  inputLabel: "tw-text-input-label",
  inputText: "tw-text-input-text",
  listItemTitle: "tw-text-list-item-title",
  button: "tw-text-button",
  headline: "tw-text-headline",
  footnote: "tw-text-footnote",
  serif: "tw-text-serif"
} as const;
